export default "__VITE_ASSET__bbbc9fcc__"